export abstract class ModalService {
    [key: string]: any;
}

export function ModalServiceFactory($injector: angular.auto.IInjectorService) {
    return $injector.get('$modal');
}

export const ModalServiceProvider = {
    provide: ModalService,
    useFactory: ModalServiceFactory,
    deps: ['$injector']
};
